export enum EnumManualAsset {
    CheckingSavings = "Checking/Savings",
    RetirementFunds = "Retirement Funds",
    RetirementFund = "Retirement Fund",
    EquityOnPendingSale = "Pending Sale",
    SecuredBorrowedFunds = "Secured Borrower Funds",
    StocksAndBonds = "Personal Investment Account",
    GiftFunds = "Gift Funds"
}